import dayjs from 'dayjs'

export const dateFormat = (date: Date, strFormat: string) => dayjs(date).format(strFormat)

export const millisecondsToDate = (millseconds: number): Date =>
  dayjs(millseconds).startOf('hour').toDate()

export const dateToMilliseconds = (date: Date): number => dayjs(date).unix() * 1e3
